<template>
  <div>
    ※本来はフォームのが横並びに増えていきます。
    <div
      v-for="(item, index) in data.Records[0].items"
      :key="index"
      class="col-auto"
    >
      <v-text-field
        v-model="item.name"
        outlined
        clearable
        background-color="white"
        :label="label"
        :rules="rules"
        type="text"
        @change="joinTextBox(0)"
      >
        <template v-slot:append-outer>
          <v-icon
            :size="values[0]"
            :style="getStyle(values[1], '+')"
            color="success"
            @click="addTextBox(index, 0)"
          >
            mdi-plus-box-outline
          </v-icon>
          <v-icon
            :size="values[0]"
            :style="getStyle(values[1], '-')"
            color="error"
            @click="removeTextBox(index, 0)"
            :disabled="index == 0"
          >
            mdi-minus-box-outline
          </v-icon>
        </template>
      </v-text-field>
    </div>
  </div>
</template>

<script>
export default {
  /*
   */
  props: {
    label: String,
    init: String,
    rules: Array,
    value: String,
  },
  data() {
    return {
      data: {
        Page_id: 0,
        Report_id: null,
        Records: [
          { value: "", form_id: 0, form_type: 11, items: [{ name: "" }] },
        ],
      },
      values: [50, 15],
    };
  },
  async mounted() {
    this.values = this.value.split(",");
    this.data.Records[0].value = this.init;
  },
  methods: {
    addTextBox(item_index, value_index) {
      this.data.Records[value_index].items.splice(item_index + 1, 0, {
        name: "",
      });
    },
    removeTextBox(item_index, value_index) {
      this.data.Records[value_index].items.splice(item_index, 1);
      this.joinTextBox(value_index);
    },
    joinTextBox(value_index) {
      this.data.Records[value_index].value = this.data.Records[
        value_index
      ].items
        .map(function(object) {
          return Object.values(object);
        })
        .join(",");
    },
    getStyle(buttom, bool) {
      if (bool == "+") {
        //'bottom:25px;left:-10px;'
        const str = "bottom:" + buttom + "px;left:-10px;";
        return str;
      } else {
        //'bottom:25px;left:-20px;'
        const str = "bottom:" + buttom + "px;left:-20px;";
        console.log(str);
        return str;
      }
    },
  },
};
</script>

<style></style>
